import ConfirmationDialog from '../../../../components/ConfirmationDialog';
import LosingChangesConfimationDialog from '../../../../components/LosingChangesConfimationDialog';
import { useLanguage } from '../../../../contexts/language';
import { ListElement } from '../../../../hooks/useDraftList';
import {
  ContractInsurance,
  VesselInsurance,
} from '../../../../types/insurance';

export interface DeleteInsuranceConfirmationDialogProps {
  insuranceItem: ListElement<
    ContractInsurance | VesselInsurance
  > | null;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteInsuranceConfirmationDialog = ({
  isLoading,
  onClose,
  onConfirm,
  insuranceItem,
}: DeleteInsuranceConfirmationDialogProps) => {
  const { t } = useLanguage();

  return (
    <>
      <LosingChangesConfimationDialog
        isOpen={Boolean(insuranceItem && insuranceItem.isDraft)}
        onConfirm={onConfirm}
        onClose={onClose}
      />
      <ConfirmationDialog
        open={Boolean(insuranceItem && !insuranceItem.isDraft)}
        onClose={onClose}
        onConfirm={onConfirm}
        loading={isLoading}
        title={t('content.insurance-deletion-confirmation.title')}
      >
        {<p>{t('content.insurance-deletion-confirmation.description')}</p>}
      </ConfirmationDialog>
    </>
  );
};

export default DeleteInsuranceConfirmationDialog;
